import { Drawer } from '@mui/material';
import React, { useState } from 'react';

const CusDrawer = ({ children, open, onClose }) => {
  return (
    <Drawer
      sx={{
        zIndex: 1250
      }}
      PaperProps={{
        sx: {
          width: ['80%', '50%', '30%'],
          borderTopLeftRadius: '22px',
          borderBottomLeftRadius: '22px'
        }
      }}
      anchor="right"
      open={open}
      onClose={onClose}
    >
      {children}
    </Drawer>
  );
};

export default CusDrawer;
